var map = {
	"./algorithms.json": 3666,
	"./diagnoses.json": 587,
	"./global.json": 4909,
	"./hpv_primary_biopsy.json": 142,
	"./hpv_primary_postcolpo.json": 3213,
	"./hpv_primary_screening.json": 8310,
	"./screening_25.json": 6552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6773;